import { LoopEnvironment } from '@shared/environments/model';
import { API_CONFIGS } from '@shared/environments/api-configs';

export const environment: LoopEnvironment = {
  name: 'sprint',
  isProduction: false,
  isUsingProxy: false,
  graphicsBaseUrl: 'assets/graphics',
  ...API_CONFIGS.SPRINT
};
